import { useI18n } from "../i18n/i18n";

export const Toast = ({
  message,
  onClose,
}: {
  message: string;
  onClose: () => void;
}) => {
  const { t } = useI18n();
  return (
    <div className="fixed left-1/2 top-6 z-50 -translate-x-1/2">
      <div className="flex items-center gap-3 rounded-md bg-emerald-600 px-4 py-3 text-sm text-white shadow-lg">
        <span>{message}</span>
        <button
          type="button"
          className="text-white/80 transition hover:text-white"
          onClick={onClose}
          aria-label={t("common.closeNotification", "Close notification")}
        >
          ×
        </button>
      </div>
    </div>
  );
};
